exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".empty-state{display:flex;flex-direction:column;align-items:center;margin-top:auto;margin-bottom:auto}.top-tab-table{margin-bottom:5px}.mdlp-dialog{max-width:100%}.md-dialog-container{width:95%;height:95%;max-width:95%;max-height:95%}.mdlp-progress{min-height:5px;height:5px;padding:0;margin-top:-16px}.mdlp-tab-button{border-radius:0;border-bottom:2px solid #fff}.mdlp-active-tab-button{border-bottom:2px solid #448aff}.md-table-fixed-header-container{overflow-x:hidden!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./Components/supportNew/mdlpLookup.vue
// module id = 416
// module chunks = 0